/**
 * Convert server pendingArranAbilityStealFlyAnimations to viewer-relative fly grant payloads.
 */

const ARRAN_ABILITY_STEAL_FLY_SOURCE = 'arran_389';

function mapBattlefieldSlotToViewer(playerId, zone, slotIndex, viewerUserId) {
  if (playerId == null || zone == null || slotIndex == null) {
    throw new Error('mapBattlefieldSlotToViewer: playerId, zone, and slotIndex are required');
  }
  const prefix = String(playerId) === String(viewerUserId) ? 'your' : 'opponent';
  return {
    zone: `${prefix}_${zone}`,
    index: slotIndex,
  };
}

function consumePendingArranAbilityStealFlyAnimations(gameStateFragment, viewerUserId) {
  if (!gameStateFragment?.pendingArranAbilityStealFlyAnimations?.length) {
    return [];
  }
  if (viewerUserId == null) {
    throw new Error('consumePendingArranAbilityStealFlyAnimations: viewerUserId is required');
  }

  const pending = [...gameStateFragment.pendingArranAbilityStealFlyAnimations];
  delete gameStateFragment.pendingArranAbilityStealFlyAnimations;

  return pending.map((anim) => {
    if (!anim.animationKey) {
      throw new Error('consumePendingArranAbilityStealFlyAnimations: animationKey is required');
    }
    if (
      anim.sourceZone == null
      || anim.sourceSlotIndex == null
      || anim.arranZone == null
      || anim.arranSlotIndex == null
      || !anim.abilityName
    ) {
      throw new Error(
        `consumePendingArranAbilityStealFlyAnimations: slots and abilityName required for ${anim.animationKey}`
      );
    }

    const fromSlot = mapBattlefieldSlotToViewer(
      anim.sourcePlayerId,
      anim.sourceZone,
      anim.sourceSlotIndex,
      viewerUserId
    );
    const toSlot = mapBattlefieldSlotToViewer(
      anim.arranPlayerId,
      anim.arranZone,
      anim.arranSlotIndex,
      viewerUserId
    );

    return {
      key: anim.animationKey,
      fromZone: fromSlot.zone,
      fromIndex: fromSlot.index,
      toZone: toSlot.zone,
      toIndex: toSlot.index,
      abilityName: anim.abilityName,
      arranInstanceId: anim.arranInstanceId,
      sequenceIndex: anim.sequenceIndex ?? 0,
      source: anim.source || ARRAN_ABILITY_STEAL_FLY_SOURCE,
    };
  });
}

module.exports = {
  ARRAN_ABILITY_STEAL_FLY_SOURCE,
  consumePendingArranAbilityStealFlyAnimations,
};
